<template>
	<div>
		<!-- <v-row class="my-3 mx-3"> -->
		<v-hover v-slot="{ hover }">
			<v-card
				class="mx-auto"
				color="grey lighten-4"
				max-width="600"
			>
				<v-img
					:aspect-ratio="16/9"
					:src="src"
					class_="d-flex justify-center text-center"
					contain
				>
					<v-expand-transition>
						<div
							v-if="hover"
							class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal text-h2 white--text"
							style="height: 100%;"
						>
							$14.99
						</div>
					</v-expand-transition>

					<!-- <v-layout class="justify-center align-center">
						<z-dialog-camera v-if="['all','camera'].includes(mode)"
							@ok="changeCamera" 
							multiple
						></z-dialog-camera>
						
						<v-btn v-if="['all','file'].includes(mode)" 
							icon x-large
							@click="onFile"
						>
							<v-icon>mdi-paperclip-plus</v-icon>
						</v-btn>
					</v-layout> -->
				</v-img>
				<v-card-text
					class="pt-6"
					style="position: relative;"
				>
					<v-btn
					absolute
					color="orange"
					class="white--text"
					fab
					large
					right
					top
					>
					<v-icon>mdi-cart</v-icon>
					</v-btn>
					<div class="font-weight-light grey--text text-h6 mb-2">
					For the perfect meal
					</div>
					<h3 class="text-h4 font-weight-light orange--text mb-2">
					QW cooking utensils
					</h3>
					<div class="font-weight-light text-h6 mb-2">
					Our Vintage kitchen utensils delight any chef.<br>
					Made of bamboo by hand
					</div>
				</v-card-text>
			</v-card>
				
			<!-- <v-card v-for="(item, i) in items" :key="i"
				class="ma-1"
				height="64"
				width="64"
				elevation="3"
			>
				<v-img 
					:src="item.url"
					:aspect-ratio="1"
					cover
					@click="$refs.dialogImage.onOpen(i)"
				></v-img>
			</v-card> -->
		</v-hover>
		<!-- </v-row> -->

		<v-progress-linear
			v-if="loading"
			color="indigo"
			:height="1"
			indeterminate
		></v-progress-linear>

		<!-- <z-dialog-review 
			ref="dialogImage"
			:items="items"
			@remove="remove"
			multiple
			:loading="loading"
		></z-dialog-review> -->

		<v-file-input 
			ref="fileinput"
			v-model="file"
			accept="image/*"
			class="d-none"
			:multiple="multiple"
			@change="changeFile"
		></v-file-input>
	</div>
</template>

<script>
import zDialogReview from '@/views/components/picture/dialog/review'
import zDialogCamera from '@/views/components/picture/dialog/camera'

//import EXIF from 'exif-js'
//import piexif from 'piexifjs'
//import pngtojpeg from 'png-to-jpeg'

export default {
	name: 'picture.photo',
	components: {
		zDialogReview,
		zDialogCamera
	},
	data: () => ({
		file: null,
	}),
    props: {
		//value: 			{ type: Array, default: () => []},
		value: 			{ type: Object, default: () => {}},
		mode: 			{ type: String, default: 'all'}, // camera | file | all
		title: 			{ type: String, default: null},
		subtitle: 		{ type: String, default: null},
		description: 	{ type: String, default: null},
		text: 			{ type: String, default: null},
		icon: 			{ type: String, default: 'mdi-halloween'},
		stacked: 		{ type: Boolean, default: false},
		multiple: 		{ type: Boolean, default: false},
		counter: 		{ type: Boolean, default: true},
		min: 			{ type: Number, default: null},
		max: 			{ type: Number, default: null},
		loading: 		{ type: Boolean, default: false},
		//resolution:		{ type: Object, default: () => ({ width: 1920, height: 1080 }) },
		resolution:		{ type: Object, default: () => ({ width: 800, height: 600 }) },
		fileName: 		{ type: String, default: 'Фото з камери'},
    },
    computed: {
		item: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},

		src() {
			return this.item?.url ? this.item.url : 'https://cdn.vuetifyjs.com/images/parallax/material.jpg'
		},

		/* count() {
			return this.items.length
		}, */
    },
	created(){
		//console.log(this.$options.name, 'created', 'type', this.type)
	},

	methods: {
		remove(e) {
			if(e) {
				//this.$emit('remove', e)
				const index = this.items.indexOf(e)
				this.items.splice(index, 1);
			}
		},

		onFile() {
			this.$refs.fileinput.$refs.input.click()
		},

		changeFile(e) {
			console.log(this.$options.name, 'changeFile', 'e', e)
			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						//let file = this.renameFile(element, )
						//this.addFile(file)
						const url = URL.createObjectURL(element);
						this.item = {
							url: url,
							file: element,
						}
					})
				} else {
					//this.addFile(e)

					const url = URL.createObjectURL(e);
					this.item = {
						url: url,
						file: e,
					}
				}
			}

			console.log(this.$options.name, 'changeFile', 'item', this.item)

			this.file = null
		},

		changeCamera(e) {
			if(e) {
				if(Array.isArray(e)) {
					e.forEach((element) => {
						this.addCamera(element)
					})
				} else {
					this.addCamera(e)
				}
			}
		},

		addCamera(blob) {
			//console.log(this.$options.name, 'add', source, 'blob', blob)

			let extension = 'jpg'
			switch(blob.type) {
				case 'image/png': extension = 'png'; break;
			}

			const fileName = `${this.fileName}.${extension}`;
			const fileBits = [blob];
			let file = new File(fileBits, fileName, {
				type: blob.type,
				//type: '',
				lastModified: Date.now()
			});

			/*
			const fileName = `${this.fileName}.jpg`;
			const fileBits = [blob];
			let file = new File(fileBits, fileName, {
				//type: blob.type,
				type: 'image/jpeg',
				lastModified: Date.now()
			});
			*/

			
			var exif = null;
			this.toJPEG(file).then((f) => file = f)
			.then(() => this.setExif(file)).then((f) => file = f)
			//.then(() => this.getExif(file)).then((e) => exif = e)
			.finally(() => {
				//console.log(this.$options.name, 'addCamera::finally', 'exif', exif)
				//console.log(this.$options.name, 'addCamera::finally', 'file', file)

				this.addFile(file, 'camera')
			});
			

			//console.log(this.$options.name, 'addCamera', 'file', file)

			//this.addFile(file, 'camera')
		},

		

		/* addFile(file, source) {
			console.log(this.$options.name, 'addFile', 'source', source, 'file', file)
			if(file) {
				const url = URL.createObjectURL(file);
					
				this.items.push({
					source: source ? source : 'file',
					url: url,
					file: file,
					//exif: exif
				})
			}
		}, */

		addFile(file, source) {
			//console.log(this.$options.name, 'addFile', 'source', source, 'file', file)

			if(file) {
				let original = this.renameFile(file, this.fileName)
				//file = this.renameFile(file, this.fileName)

				file = new File([original], original.name, { type: original.type, lastModified: original.lastModified })


				var exif = null;
				this.getExif(file)
				.then((e) => exif = e)
				.then(() => this.resizeFile(file))
				.then((fl) => file = fl)
				.then(() => this.copyExif(original, file))
				.then((fl) => file = fl)
				/*
				const modifNewfile = that.copyExif(file, newfile);

							console.log(that.$options.name, 'resizeFile', 'modifNewfile', modifNewfile)

							resolve(modifNewfile);
				*/
				.finally(() => {
					//console.log(this.$options.name, 'addFile::finally', 'exif', exif)
					//console.log(this.$options.name, 'addFile::finally', 'file', file)
					
					const url = URL.createObjectURL(file);
					
					/* this.$emit('add', {
						source: source ? source : 'file',
						url: url,
						file: file,
						exif: exif
					}) */

					this.items.push({
						source: source ? source : 'file',
						url: url,
						file: file,
						exif: exif
					})
				});
			}
		},

		/**
		 * Rename of File
		 * @param originalFile - оригінальний файл
		 * @param newName - нова назва без розширення
		 */
		renameFile(originalFile, newName) {
			//var re = /(?:\.([^.]+))?$/;
			//const extention = re.exec(originalFile.name)[1];
			const extention = originalFile.name.split('.').pop();
			const fileName = `${newName}.${extention}`;

			return new File([originalFile], fileName, {
				type: originalFile.type,
				lastModified: originalFile.lastModified,
			});
		},

		/**
		 * Resizing the File
		 * https://cloudinary.com/guides/bulk-image-resize/transform-your-visuals-how-to-resize-an-image-in-javascript
		 * @param file 
		 */
		async resizeFile(file) {
			//console.log(this.$options.name, 'resizeFile', 'file', file)

			var that = this

			//const dataURL = URL.createObjectURL(file);
			//var exif = piexif.load(dataURL);

			//var exif = await this.getExif(file);
			//console.log(this.$options.name, 'resizeFile', 'exif', exif)


			/* var dataURL = await this.getDataURL(file);

			console.log(this.$options.name, 'resizeFile', 'dataURL', dataURL)

			var exifObj = piexif.load(dataURL);

			console.log(this.$options.name, 'resizeFile', 'exifObj', exifObj)

			var exifStr = piexif.dump(exifObj) // Get exif as string to insert into JPEG.

			console.log(this.$options.name, 'resizeFile', 'exifStr', exifStr) */

			//var exifObj = await this.setExifObject(file);
			//console.log(this.$options.name, 'resizeFile', 'exifObj', exifObj);

			return await new Promise(resolve => {
				if(file.size > 2*1024*1024) {
					var img = new Image();
					img.src = URL.createObjectURL(file);
					img.onload = function() {
						//console.log(that.$options.name, 'addFile', 'width', this.width, 'height', this.height, 'img', this)

						var maxWidth = that.resolution.width; // Define the maximum width of the image
						var maxHeight = that.resolution.height; // Define the maximum height of the image

						var width = this.width;
						var height = this.height;

						// Calculate the new dimensions, maintaining the aspect ratio
						if (width > height) {
							if (width > maxWidth) {
								height *= maxWidth / width;
								width = maxWidth;
							}
						} else {
							if (height > maxHeight) {
								width *= maxHeight / height;
								height = maxHeight;
							}
						}

						// Set the canvas dimensions to the new dimensions
						var canvas = document.createElement('canvas');
						canvas.width = width;
						canvas.height = height;

						// Draw the resized image on the canvas
						var ctx = canvas.getContext('2d');
						ctx.drawImage(this, 0, 0, width, height);

						//console.log(this.$options.name, 'resizeFile', 'canvas.width', canvas.width, 'canvas.height', canvas.height)
						//console.log(this.$options.name, 'resizeFile', 'image.width', image.width, 'image.height', image.height)
						
						const quality = 1.0
						canvas.toBlob((blob) => {
							const newfile = new File([blob], file.name, {
								type: file.type,
								lastModified: file.lastModified
							});

							resolve(newfile);

						}, "image/jpeg", quality);
						
					};
				} else {
					resolve(file); 
				}
			});
		},

		/**
		 * Resizing to JPEG
		 * @param file 
		 */
		
		/* convertDataURIToBinary(dataURI) {
			var BASE64_MARKER = ';base64,';
			var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
			var base64 = dataURI.substring(base64Index);
			var raw = window.atob(base64);
			var rawLength = raw.length;
			var array = new Uint8Array(new ArrayBuffer(rawLength));

			for (let i = 0; i < rawLength; i++) {
				array[i] = raw.charCodeAt(i);
			}
			return array;
		}, */

		/* getBase64Image(img) {
			// Создаем пустой canvas
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;

			// Копируем изображение в контекст canvas'a
			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);

			// Получаем data-URL изображения
			return canvas.toDataURL("image/png");

			//return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
		}, */

		async getDataURL(file) {
			//return await new Promise(resolve => {
			return new Promise(resolve => {

				var img = new Image();
				img.src = URL.createObjectURL(file);
				img.onload = function() {
					var width = this.width,
						height = this.width
					;

					var canvas = document.createElement("canvas");
					canvas.width = width;
					canvas.height = height;
					//canvas.getContext("2d").drawImage(img, 0, 0);

					// Копируем изображение в контекст canvas'a
					var ctx = canvas.getContext("2d");
					ctx.drawImage(img, 0, 0);

					var dataURL  = canvas.toDataURL(file.type);

					resolve(dataURL);
				}
			})
		},

		async toJPEG(file) {
			//console.log(this.$options.name, 'toJPEG', 'file', file)

			var that = this
			return await new Promise(resolve => {
				//console.log(that.$options.name, 'toJPEG', 'file.type', file.type)
				if(file.type == 'image/jpeg') {
					resolve(file);
				} else {

					//console.log(that.$options.name, 'toJPEG', 'file.type', file.type)
					//console.log(that.$options.name, 'toJPEG', 'file.nativeURL', file.nativeURL)

					var img = new Image();
					img.src = URL.createObjectURL(file);
					img.onload = function() {
						var width = img.naturalWidth,
							height = img.naturalHeight;

						//console.log(width, height)
						window.URL.revokeObjectURL( img.src );

						var canvas = document.createElement("canvas");
						canvas.width = width;
						canvas.height = height;
						//canvas.getContext("2d").drawImage(img, 0, 0);

						// Копируем изображение в контекст canvas'a
						var ctx = canvas.getContext("2d");
						ctx.drawImage(img, 0, 0);

						var img_link    = canvas.toDataURL("image/jpeg");

						
						//console.log(img_link)
						//jpg.src = img_link

						//that.setExif(img_link)

						const quality = 1.0
						canvas.toBlob((blob) => {
							//console.log(that.$options.name, 'toJPEG', 'blob', blob)

							const extention = 'jpg';						
							const fileName = file.name.replace(/\.[^/.]+$/, "")+`.${extention}`;

							const newfile = new File([blob], fileName, { type: blob.type });

							//console.log(that.$options.name, 'toJPEG', 'newfile', newfile)

							//const url = URL.createObjectURL(newfile);
							//console.log(that.$options.name, 'toJPEG', 'url', url)

							resolve(newfile);
						}, "image/jpeg", quality);
					}
				}
			})
			
		},

		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		async getExif(file) {
			//console.log(this.$options.name, 'getExif', 'file', file)
			//return await new Promise(resolve =>
			return new Promise(resolve =>
				EXIF.getData(file, function() {
					//console.log('getExif', 'exif', EXIF.getAllTags(this))
					resolve(EXIF.getAllTags(this)); 
				}
			));
		},

		async setExifObject(file) {
			return new Promise(resolve => {
				var reader = new FileReader();
				reader.onloadend = function(e) {
					var exifObj = piexif.load(e.target.result);
					//console.log(that.$options.name, 'resizeFile', 'exifObj', exifObj)
					resolve(exifObj);
				};
				reader.readAsDataURL(file);
			});
		},

		/**
		 * Copy EXIF from fileSource to fileTarget
		 * https://piexifjs.readthedocs.io/en/latest/sample.html
		 */
		async copyExif(fileSource, fileTarget) {
			//console.log(this.$options.name, 'copyExif', 'fileSource', fileSource)
			//console.log(this.$options.name, 'copyExif', 'fileTarget', fileTarget)

			var that = this
			return new Promise(resolve => {
				var readerSource = new FileReader();
				readerSource.onloadend = function(es) {
					var exifObj = piexif.load(es.target.result);
					var exifStr = piexif.dump(exifObj);
					//console.log(that.$options.name, 'copyExif', 'exifObj', exifObj)

					var readerTarget = new FileReader();
					readerTarget.onloadend = function(et) {
						//console.log(that.$options.name, 'copyExif', 'et', et)

						var jpegData = et.target.result;

						//console.log(that.$options.name, 'copyExif', 'jpegData', jpegData)

						var exifModified = piexif.insert(exifStr, jpegData);

						var jpegBinary = atob(exifModified.split(",")[1]);
						var data = [];
						for (var p=0; p<jpegBinary.length; p++) {
							data[p] = jpegBinary.charCodeAt(p);
						}
						var ua = new Uint8Array(data);
						var blob = new Blob([ua], {type: fileTarget.type});

						const newfile = new File([blob], fileTarget.name, {
							type: fileTarget.type,
							lastModified: fileTarget.lastModified
						});

						//console.log(that.$options.name, 'copyExif', 'newfile', newfile)

						resolve(newfile);
					};
					readerTarget.readAsDataURL(fileTarget);

				};
				readerSource.readAsDataURL(fileSource);
			});
		},


		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		async setExif(file) {
			//console.log(this.$options.name, 'setExif', 'file', file)

			//const url = URL.createObjectURL(file);
			//console.log(this.$options.name, 'setExif', 'url', url)

			var jpegData = await this.getDataURL(file);

			//var jpegData = document.getElementById("canvas").toDataURL("image/jpeg", 1.0);

			var that = this
			return await new Promise(resolve => {
				var zeroth = {};
				var exif = {};
				var gps = {};
				zeroth[piexif.ImageIFD.Make] = "Make";
				zeroth[piexif.ImageIFD.XResolution] = [777, 1];
				zeroth[piexif.ImageIFD.YResolution] = [777, 1];
				zeroth[piexif.ImageIFD.Software] = "GreenDoor";
				//exif[piexif.ExifIFD.DateTimeOriginal] = "2010:10:10 10:10:10";
				//exif[piexif.ExifIFD.DateTimeOriginal] = Date.now();
				exif[piexif.ExifIFD.DateTimeOriginal] = (new Date()).toISOString();
				exif[piexif.ExifIFD.LensMake] = "LensMake";
				exif[piexif.ExifIFD.Sharpness] = 777;
				exif[piexif.ExifIFD.LensSpecification] = [[1, 1], [1, 1], [1, 1], [1, 1]];
				gps[piexif.GPSIFD.GPSVersionID] = [7, 7, 7, 7];
				//gps[piexif.GPSIFD.GPSDateStamp] = "1999:99:99 99:99:99";
				gps[piexif.GPSIFD.GPSDateStamp] = (new Date()).toISOString();

				//gpsIfd[piexif.GPSIFD.GPSLatitudeRef] = lat < 0 ? 'S' : 'N';
				//gpsIfd[piexif.GPSIFD.GPSLatitude] = piexif.GPSHelper.degToDmsRational(lat);
				//gpsIfd[piexif.GPSIFD.GPSLongitudeRef] = lng < 0 ? 'W' : 'E';
				//gpsIfd[piexif.GPSIFD.GPSLongitude] = piexif.GPSHelper.degToDmsRational(lng);

				var exifObj = {"0th":zeroth, "Exif":exif, "GPS":gps};
				//var exifStr = piexif.dump(exifObj);


				// get exif binary as "string" type
				var exifBytes = piexif.dump(exifObj);

				// get JPEG image from canvas
				//var jpegData = document.getElementById("canvas").toDataURL("image/jpeg", 1.0);

				// insert exif binary into JPEG binary(DataURL)
				var exifModified = piexif.insert(exifBytes, jpegData);

				var jpegBinary = atob(exifModified.split(",")[1]);
				var data = [];
				for (var p=0; p<jpegBinary.length; p++) {
					data[p] = jpegBinary.charCodeAt(p);
				}
				var ua = new Uint8Array(data);
				var blob = new Blob([ua], {type: "image/jpeg"});

				const newfile = new File([blob], file.name, {
					type: file.type,
					lastModified: file.lastModified
				});

				//console.log(that.$options.name, 'setExif', 'newfile', newfile)

				resolve(newfile);
			});
		},
	},
}
</script>